// @ts-nocheck
import BaseComponent from "base/common/RoutingComponent";
import AppSetting from "config/AppSetting";
import { PmpMetricReportKey } from "../constants";
import { handleUserRoleOnlyOpex } from "utils";

export default class reportIFrame extends BaseComponent {
  constructor(props: any) {
    super(props);
  }

  iFrameHeight = () => {
    var n = document.getElementById("iframepage");
    if (!n) return;
    // @ts-ignore
    n.height = document.documentElement.clientHeight;
  };

  componentDidMount() {
    this.validateToken();
  }

  render() {
    const internalUserID = AppSetting.localStorageValue.user.get().identityUserInfo.internalUserID;
    const reportKey = this._getRoutingParam("ReportKey");

    const isPmpMetricKey = Object.values(PmpMetricReportKey).includes(reportKey);
    if (isPmpMetricKey && !handleUserRoleOnlyOpex(AppSetting.localStorageValue.role.get())) {
      window.location = "/NoPermissionPage/noAccess";
      return <span>Not Found This Report</span>;
    }

    const reportLinks = [
      {
        key: "ProcedureMasterList",
        value: `${process.env.REPORT_PROCEDURE_MASTER_LIST}&IdentityUserID=${internalUserID}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: "ProcedureUpdateTrackingLog",
        value: `${process.env.REPORT_PROCEDURE_UPDATE_TRACKING_LOG}&IdentityUserID=${internalUserID}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: "TeamLeaderProcedureReviewTrackingLog",
        value: `${process.env.REPORT_PROCEDURE_TEAM_LEADER_PROCEDURE_REVIEW}&IdentityUserID=${internalUserID}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: "SharingRelationshipTrackingLog",
        value: `${process.env.REPORT_PROCEDURE_SHARING_RELATIONSHIP}&IdentityUserID=${internalUserID}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: "ProcessList",
        value: `${process.env.REPORT_PROCEDURE_PROCESS_LIST}&IdentityUserID=${internalUserID}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: "FileList",
        value: `${process.env.REPORT_PROCEDURE_FILE_LIST}&IdentityUserID=${internalUserID}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: "MonitoringReport",
        value: `${process.env.REPORT_PROCEDURE_MONITORING_REPORT}&IdentityUserID=${internalUserID}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric1,
        value: `${process.env.REPORT_PMP_METRIC_1}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric2AccountLevel,
        value: `${process.env.REPORT_PMP_METRIC_2_ACCOUNT_LEVEL}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric2TaskLevel,
        value: `${process.env.REPORT_PMP_METRIC_2_TASK_LEVEL}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric3,
        value: `${process.env.REPORT_PMP_METRIC_3}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric4AccountLevel,
        value: `${process.env.REPORT_PMP_METRIC_4_ACCOUNT_LEVEL}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric4ProcedureChangeLog,
        value: `${process.env.REPORT_PMP_METRIC_4_PROCEDURE_CHANGE_LOG}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric5,
        value: `${process.env.REPORT_PMP_METRIC_5}&rc:Zoom=100%&rs:Embed=true`,
      },
      {
        key: PmpMetricReportKey.Metric6,
        value: `${process.env.REPORT_PMP_METRIC_6}&rc:Zoom=100%&rs:Embed=true`,
      },
    ];

    const reportLink = reportLinks.find((x) => x.key === reportKey)?.value ?? null;

    return reportLink == null ? (
      <span>Not Found This Report</span>
    ) : (
      // @ts-ignore
      <iframe
        id="iframepage"
        scrolling="no"
        frameBorder={"0"}
        src={reportLink}
        testid="report-iframe"
        // onload={this.iFrameHeight()}
        height="100%"
        width={"100%"}
      ></iframe>
    );
  }
}
